module.exports = __webpack_public_path__ + "static/media/laptop.d4f564df.jpg";